import api from './client'


export const organizerApi = {
  getEvents: (params) => api.get('/organizer/events', { params }),
  getEvent: (eventId) => api.get(`/events/${eventId}`),
  getApplications: (eventId, params) => api.get(`/events/${eventId}/applications`, { params }),
  acceptApplication: (applicationId) => api.post(`/applications/${applicationId}/accept`),
  rejectApplication: (applicationId, data) => api.post(`/applications/${applicationId}/reject`, data),
  getEventResults: (eventId) => api.get(`/events/${eventId}/results`),
  createResult: (eventId, data) => api.post(`/events/${eventId}/results`, data),
  updateResult: (resultId, data) => api.put(`/results/${resultId}`, data),
  deleteResult: (resultId) => api.delete(`/results/${resultId}`)
}
